import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function sortingButton(theme: Theme): ComponentStyle {
  return {
    componentName: 'sortingButton',
    baseStyle: {
      gap: theme.space['3xs']
    },
    variants: {
      active: {
        color: theme.colors.linkHover
      }
    }
  };
}
